<template>
  <NewsFeed />
</template>

<script>
import NewsFeed from '@/components/content/NewsFeed.vue'

export default {
  name: 'NewsFeedPage',
  components: { NewsFeed }
}
</script>

<style scoped>

</style>
